import React, { useState } from 'react';
import { ChevronRight, ChevronDown } from 'lucide-react';
import TipoBadge from './TipoBadge';
import NaturaBadge from './NaturaBadge';

export interface CentroCostoNode {
  id: string;
  codice: string;
  nome: string;
  tipo: string;
  natura: string;
  attivo: boolean;
  children: CentroCostoNode[];
}

interface TreeNodeProps {
  node: CentroCostoNode;
  level: number;
  onSelect: (id: string) => void;
}

const TreeNode: React.FC<TreeNodeProps> = ({ node, level, onSelect }) => {
  const [expanded, setExpanded] = useState(true);
  const hasChildren = node.children && node.children.length > 0;

  return (
    <div>
      <div
        className={`flex items-center gap-2 py-1.5 px-2 rounded hover:bg-gray-50 cursor-pointer ${!node.attivo ? 'opacity-40' : ''}`}
        style={{ paddingLeft: `${level * 20 + 8}px` }}
      >
        {/* Expand/collapse toggle */}
        <button
          className="shrink-0 text-gray-400 hover:text-gray-600"
          onClick={(e) => {
            e.stopPropagation();
            setExpanded((v) => !v);
          }}
        >
          {hasChildren ? (
            expanded ? (
              <ChevronDown className="h-4 w-4" />
            ) : (
              <ChevronRight className="h-4 w-4" />
            )
          ) : (
            <span className="h-4 w-4 block" />
          )}
        </button>

        {/* Node label */}
        <span
          className="flex-1 text-sm font-medium text-gray-800 truncate"
          onClick={() => onSelect(node.id)}
        >
          <span className="text-gray-400 mr-1">{node.codice}</span>
          {node.nome}
        </span>

        <div className="flex items-center gap-1 shrink-0" onClick={() => onSelect(node.id)}>
          <TipoBadge tipo={node.tipo} />
          <NaturaBadge natura={node.natura} />
        </div>
      </div>

      {hasChildren && expanded && (
        <div>
          {node.children.map((child) => (
            <TreeNode key={child.id} node={child} level={level + 1} onSelect={onSelect} />
          ))}
        </div>
      )}
    </div>
  );
};

export default TreeNode;
